"use strict";
// https://github.com/Chia-Network/chia-blockchain/blob/main/chia/wallet/derive_keys.py
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeriveKeysUtils = void 0;
const clvm_1 = require("clvm");
class DeriveKeysUtils {
    static derivePath(sk, path) {
        const { AugSchemeMPL } = (0, clvm_1.getBLSModule)();
        for (const index of path) {
            sk = AugSchemeMPL.derive_child_sk(sk, index);
        }
        return sk;
    }
    static derivePathUnhardened(sk, path) {
        const { AugSchemeMPL } = (0, clvm_1.getBLSModule)();
        for (const index of path) {
            sk = AugSchemeMPL.derive_child_sk_unhardened(sk, index);
        }
        return sk;
    }
    static masterSkToFarmerSk(master) {
        return this.derivePath(master, [12381, 8444, 0, 0]);
    }
    static masterSkToPoolSk(master) {
        return this.derivePath(master, [12381, 8444, 1, 0]);
    }
    static masterSkToWalletSkIntermediate(master) {
        return this.derivePath(master, [12381, 8444, 2]);
    }
    static masterSkToWalletSk(master, index) {
        const intermediate = this.masterSkToWalletSkIntermediate(master);
        return this.derivePath(intermediate, [index]);
    }
    static masterSkToWalletSkUnhardenedIntermediate(master) {
        return this.derivePathUnhardened(master, [12381, 8444, 2]);
    }
    static masterSkToWalletSkUnhardened(master, index) {
        const intermediate = this.masterSkToWalletSkUnhardenedIntermediate(master);
        return this.derivePathUnhardened(intermediate, [index]);
    }
    static masterSkToLocalSk(master) {
        return this.derivePath(master, [12381, 8444, 3, 0]);
    }
    static masterSkToBackupSk(master) {
        return this.derivePath(master, [12381, 8444, 4, 0]);
    }
    static masterSkToSingletonOwnerSk(master, poolWalletIndex) {
        // This key controls a singleton on the blockchain, allowing for dynamic pooling (changing pools)
        return this.derivePath(master, [12381, 8444, 5, poolWalletIndex]);
    }
    static masterSkToPoolingAuthenticationSk(master, poolWalletIndex, index) {
        // This key is used for the farmer to authenticate to the pool when sending partials
        if (index >= 10000) {
            throw new Error("assert index < 10000");
        }
        if (poolWalletIndex >= 10000) {
            throw new Error("assert pool_wallet_index < 10000");
        }
        return this.derivePath(master, [12381, 8444, 6, poolWalletIndex * 10000 + index]);
    }
    static masterPkToWalletPkUnhardened(master, index) {
        const { AugSchemeMPL } = (0, clvm_1.getBLSModule)();
        const derivationPath = [12381, 8444, 2, index];
        let key = master;
        for (const i of derivationPath) {
            key = AugSchemeMPL.derive_child_pk_unhardened(key, i);
        }
        return key;
    }
}
exports.DeriveKeysUtils = DeriveKeysUtils;
DeriveKeysUtils.MAX_POOL_WALLETS = 100;
//# sourceMappingURL=derive_keys.js.map